module.exports = __webpack_public_path__ + "img/701522934.40517f85.jpg";